export default __webpack_public_path__ + "static/media/water.0a105b3e.svg";